/*eslint-disable no-undef*/
import React, {useState, useEffect} from 'react';
import { connect } from "react-redux";
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import _isEqual from 'lodash/isEqual'
import _isEmpty from 'lodash/isEmpty'
import url from 'url';
import LMap from './LMap';
function MiddlewareLMap({
   config,
   tagsList,
   boothConfiguration,
   boothConfigurationLoading,
   boothsRequestLoader
}) {
   const [sourceHex, setSourceHex]= useState(null);
   useEffect(() => {
      let url_obj = url.parse(window.location.href);
      let hostname = url_obj.hostname;
      let source_hex = null;
      if (hostname != "localhost") {
         source_hex = hostname.split(".")[0];
      }
      setSourceHex(source_hex);
   }, [])
   const {base_image_url, image_info, floorplan_id, PublicFloorplanConfig} = boothConfiguration || {};
   return (
      <>
         {boothConfigurationLoading && (
            <Spin className="page-loader" spinning={true} indicator={<LoadingOutlined style={{ fontSize: 30 }}/>}></Spin>
         )}
         {!boothConfigurationLoading && !_isEmpty(boothConfiguration) && 
            <LMap
               floorplan={base_image_url}
               image_width={image_info.width}
               image_height={image_info.height}
               mode={mode}
               ConfID={config['exhibitor_confid']}
               floorplan_id={floorplan_id}
               public_floorplan_config={PublicFloorplanConfig ? JSON.parse(PublicFloorplanConfig) : {}}
               tags={tagsList}
               config={config}
               source_hex={config.source_hex ? config.source_hex : sourceHex}
            />
         }
      </>
   )
}

const mapStateToProps = ({ exhibFloor }) => {
   return { 
      config: exhibFloor.config, 
      tagsList: exhibFloor.tagsList,
      boothConfiguration: exhibFloor.boothConfiguration,
      boothConfigurationLoading: exhibFloor.boothConfigurationLoading
   }
}

export default connect(mapStateToProps, null)(MiddlewareLMap)